import React from "react";
import PropTypes from "prop-types";
import className from "./style.module.scss";
import { LabelTooltip } from "../../LabelTooltip";
import { MICROPIPETTE_TYPE } from "@learningblocks/exp-constants/lib/Utilities";
import {
  P2_TipBox_Closed,
  P20_TipBox_Closed,
  P200_TipBox_Closed,
  P1000_TipBox_Closed,
  P2_TipBox_Open,
  P20_TipBox_Open,
  P200_TipBox_Open,
  P1000_TipBox_Open,
} from "../../Icons";
import { Image } from "@learningblocks/shared-components";

const { P2, P20, P200, P1000 } = MICROPIPETTE_TYPE;
const TIP_BOXES = {
  [P2]: {
    label: "P2 Tips",
    image_open: P2_TipBox_Open,
    image_closed: P2_TipBox_Closed,
  },
  [P20]: {
    label: "P20 Tips",
    image_open: P20_TipBox_Open,
    image_closed: P20_TipBox_Closed,
  },
  [P200]: {
    label: "P200 Tips",
    image_open: P200_TipBox_Open,
    image_closed: P200_TipBox_Closed,
  },
  [P1000]: {
    label: "P1000 Tips",
    image_open: P1000_TipBox_Open,
    image_closed: P1000_TipBox_Closed,
  },
};

/**
 * PipetteTipBox:
 *  - Box of tips to attach to a MicroPipette
 */
export function PipetteTipBox(props) {
  const getImage = (tip) => (props.open ? tip.image_open : tip.image_closed);

  const tip = TIP_BOXES[props.type];

  const onClick = () => props.toggleBoxOpen(!props.open);

  const getLabelStyle = () => {
    const style = { position: "absolute", top: "15px", whiteSpace: "nowrap" };
    if (props.open) {
      style.top = "-40px";
    }
    return style;
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={className.tipBox}
      onClick={onClick}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick();
        }
      }}
    >
      <LabelTooltip labelStyle={getLabelStyle()} label={tip.label} />
      <Image
        className={className.image}
        src={getImage(tip)}
        alt={`Pipette tip box labeled ${tip.label}.`}
      />
    </div>
  );
}

PipetteTipBox.propTypes = {
  /**
   * Type of MicroPipette TipBox [ P2, P20, P200, P1000]
   */
  type: PropTypes.oneOf([P2, P20, P200, P1000]).isRequired,
  /**
   * Boolean to set it box is open/closed
   */
  open: PropTypes.bool,
  /**
   * Callback to Open/Close TipBox
   */
  toggleBoxOpen: PropTypes.func,
};

PipetteTipBox.defaultProps = {
  type: P2,
};
